import { Expose } from "class-transformer";

export class CreateProjectHasWarehouseDto {
  @Expose()
  projectId: string;

  @Expose()
  warehouseId: string;
}
